import _ from 'lodash';

import { TTimeRecord } from 'com/DeckGraph/types';

export default function (data: TTimeRecord[]) {
  const dataSorted = _.sortBy(data, item => item.weeks);

  const maxCount: number = Math.max(
    10,
    _.maxBy(data, item => item.count)?.count || 0
  );

  const maxWeeks: number = Math.max(
    10,
    _.maxBy(data, item => item.weeks)?.weeks || 0
  );

  return { dataSorted, maxCount, maxWeeks };
}
